import { get } from 'lodash'
import { CONFIGURATION_KEYS } from '../../constants/enums'

export default function(fields, localeId = 2, configuration) {

  const minAgeCfg = get(configuration, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

  return {
    ...fields,
    isAlreadyRunningAward: get(fields, 'isAlreadyRunningAward') === 'yes',
    localeId,
    helpers: undefined,
    emailAgain: undefined,
    awardLeaderRegistration: {
      ...get(fields, 'awardLeaderRegistration'),
      countryId: get(fields, 'countryId'),
      isCoordinator: true,
      localeId,
      minAgeValue: minAgeCfg
    },
    noPartOfGOP: true
  }
}
